<div id="stationListModal" class="modal is-touch is-short" [ngClass]="{ 'is-open': isUnderHoodModalOpen}">
  @if (isUnderHoodModalOpen) {
    <div class="modal__content">
      <div class="modal__header">
        <div class="container">
          <div class="row no-edge-gutters">
            <div class="col-11 flex">
              <svg class="width-4 height-4 fill-warning-dark pt1 mr2">
                <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
              </svg>
              <div>
                <h2 class="h2" id="stationListModalHeader" [innerHtml]="primaryHeader"></h2>
                <div class="h4 gray-40" id="modalSubHeader" [innerHtml]="subHeader"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__body pt0 pr0">
        <div class="touch-table__table-wrapper">
          <table class="touch-table bg-white">
            <thead>
              <tr>
                <th class="left gray-62 col-4">Clinic</th>
                <th class="left gray-62 col-4">Station</th>
                <th class="left gray-62 col-2">Dispense Type</th>
                <th class="center gray-62 whitespace-nowrap">
                  <div class="whitespace-nowrap" id="modalColumn1">{{column1Text}}</div>
                  <div class="italic" id="modalColumn2">{{column2Text}}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (item of selectedItems | paginate: pagingConfig; track trackItem(i, item); let i = $index) {
                <tr>
                  <td class="table--fill-remaining-width">
                    <div class="drug-name--primary truncate" id="staionModalClinicName{{i}}">{{item.clinicName}}</div>
                  </td>
                  <td>
                    <div class="drug-name--primary truncate" id="staionModalName{{i}}">{{item.stationName}}</div>
                  </td>
                  <td class="bold">{{item.dispenseType}}</td>
                  @if (showQOHDiv) {
                    <td class="bold center" id="staionModalInvUnits{{i}}">{{item.underhoodQoh}} {{item.invUnits}}</td>
                  } @else {
                    <td class="bold center" id="stationModalWitness{{i}}">{{item.isWitness}}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
          <ul class="touch-pagination">
            <div nc-pagination-controls [config]="pagingConfig"></div>
          </ul>
        </div>
      </div>
      <div class="modal__footer flex flex-auto justify-content-end">
        <button class="btn btn--true-blue" id="closeStationListModal" (click)="closeUnderHoodModal()">Ok</button>
      </div>
    </div>
  }
</div>
